import React, { Component } from 'react'
import { NavLink, Link } from 'react-router-dom';

class NavEx extends Component {
    constructor(props) {
        super(props)
        this.setState({ navigator: this.navigator });
    }

    routes = [
        { to: '/', label: '', order: 1 },
        { to: '/1', label: '1', order: 2 },
        { to: '/2', label: '2', order: 3 },
        { to: '/5', label: '5', order: 4 },
        { to: '/6', label: '6', order: 5 },
        { to: '/10', label: '10', order: 6 },
        { to: '/12', label: '12', order: 7 },
        { to: '/14', label: '14', order: 8 },
        { to: '/15', label: '15', order: 9 },
        { to: '/measuring-productive-sustainable-agriculture', label: '', order: 10 },
        { to: '/conflict-snapshot', label: '', order: 11 },
        { to: '/annex', label: '', order: 12 },
    ];

    navigator = { id: 0, current: { to: '/', label: '', order: 1 }, previous: { to: '/', label: '', order: 1 }, next: { to: '/1', label: '1', order: 2 } };

    onChangeState(from, id) {


        let prev = 1;
        let next = 12;
        if (id > 1) {
            prev = id - 1;
        }
        if (id < 12) {
            next = id + 1;
        }

        let prevTo = '';
        let nextTo = '';
        let current = '';

        this.routes.forEach(function (e) {
            if (e.order === id) {
                current = e;
            }
            if (e.order === prev) {
                prevTo = e;
            }
            if (e.order === next) {
                nextTo = e;
            }
        });


        this.navigator.id = id;
        this.navigator.previous = prevTo;
        this.navigator.next = nextTo;
        this.navigator.current = current;

        this.setState({ navigator: this.navigator });
    }



    render() {
        const links = this.routes.map(({ to, label, order }) => {
            return <NavLink
                onClick={() => this.onChangeState('NavLink', order)}
                to={{
                    pathname: to
                }}
                className="swiper-pagination-bullet"
                state={{ order: order }}
                key={to}>{label}
            </NavLink>
        }
        )

        return (<div className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-ios sdg-swiper">
            <Link onClick={() => this.onChangeState('Link', this.navigator.previous.order)} to={{ pathname: this.navigator.previous.to }}
                className="swiper-button-prev" state={{ order: this.navigator.previous.order }} ></Link>
            <Link onClick={() => this.onChangeState('Link', this.navigator.next.order)} to={{ pathname: this.navigator.next.to }}
                className="swiper-button-next" state={{ order: this.navigator.next.order }} ></Link>
            <nav className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets">
                {links}
            </nav>
        </div>)
    }

}

export default NavEx
